// extracted by mini-css-extract-plugin
module.exports = {"modal-coming-soon":"ModalComingSoon_modal-coming-soon__sjBMQ","content":"ModalComingSoon_content__38pfI"};